import Cookies from 'js-cookie'
export const CookiesHelper = {

    set: function (key, value, expiresTime) {
        //Default: Cookie is removed when the user closes the browser.
        var endcodeValue = window.btoa(unescape(encodeURIComponent(value)));
        //expires in day
        Cookies.set(key, endcodeValue, { expires: expiresTime });
    },
    get: function (key) {
        var value = Cookies.get(key);
        try {
            value = decodeURIComponent(escape(window.atob(value)));
        } catch (err) {
        }
        return value;
    },
    remove: function (key) {
        Cookies.remove(key);
    },
    
    //https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
    setSessionStorage: function (key, value) {
        if (typeof window.sessionStorage != 'undefined') {
            var endcodeValue = window.btoa(unescape(encodeURIComponent(value)));
            window.sessionStorage.setItem(key, endcodeValue);
        }
    },
    getSessionStorage: function (key) {
        if (typeof window.sessionStorage != 'undefined') {
            var value = window.sessionStorage.getItem(key);
            try {
                value = decodeURIComponent(escape(window.atob(value)));
            } catch (err) {
            }
            return value;
        }
        return null;
    },
    removeSessionStorage: function (key) {
        if (typeof window.sessionStorage != 'undefined') {
            window.sessionStorage.removeItem(key);
        }
    },
}